"use client";
import { Slide } from "@chakra-ui/react";
import { type RscRouterParameters } from "@ui/components/search/hooks/rsc-router-params";
import { type NextRouter } from "next/router";
import { useEffect } from "react";
import { atom, useAtom } from "jotai";
import LoadingWrapper, { type LoadingProps } from "./loading-wrapper";

export type NextRouterHandler = (...events: any[]) => void;

export type LoadingCtxType = {
  props: LoadingProps;
  isOpen: boolean;
};
export const defaultLoadingCtx: LoadingCtxType = {
  props: {
    message: ["Loading"],
    colorScheme: "blue",
    containerSx: {
      h: {
        base: "calc(100vh - 56px)",
        lg: "calc(100vh - 52px)",
      },
      w: "100vw",
      mt: {
        base: "-56px",
        lg: "-52px",
      },
      bg: "white",
    },
  },
  isOpen: false,
};

export const loadingCtx = atom<LoadingCtxType>(defaultLoadingCtx);

export default function LoadingContext({ router, rsc }: RscRouterParameters) {
  const [ctx, setCtx] = useAtom(loadingCtx);
  useEffect(() => {
    const routeChangeComplete: NextRouterHandler = () => {
      setCtx({
        ...defaultLoadingCtx,
        isOpen: false,
      });
    };

    if (ctx?.isOpen) {
      window.scrollTo(0, 0);
      document.body.style.overflow = "hidden";
    }
    if (!ctx?.isOpen) {
      document.body.style.overflow = "auto";
    }

    !rsc &&
      (router as NextRouter).events.on(
        "beforeHistoryChange",
        routeChangeComplete,
      );

    return () => {
      !rsc &&
        (router as NextRouter).events.off(
          "beforeHistoryChange",
          routeChangeComplete,
        );
    };
  }, [ctx]);

  return (
    <Slide
      direction="bottom"
      in={ctx.isOpen}
      style={ctx.isOpen ? { zIndex: 8 } : { zIndex: -1 }}
    >
      <LoadingWrapper {...ctx?.props} />
    </Slide>
  );
}
